const headerWithImage = document.querySelector('.header--has-image');
const headerImage = headerWithImage ? headerWithImage.querySelector('.header__image') : null;
const headerImageBlurClass = 'header__image--blur';

if (headerWithImage && headerImage) {
    // The header image is blurred as soon as the bottom of the header window
    // is positioned above the given factor of the screen height.
    const blurThreasholdFactor = .8;

    const observerOptions = {
        threshold: [0, .1, .2, .3, .4, .5, .6, .7, .8, .9, 1],
    };

    const observer = new IntersectionObserver(entries => {
        // distance between upper window bound and the bottom of the header
        const headerBottomDistance = entries[0].boundingClientRect.bottom;
        // threshold (measured by header bottom position) for toggling the header blur
        const blurThreshold = window.innerHeight * blurThreasholdFactor;
        // never blur the header if the scroll position is at the very top
        const isScrolled = window.scrollY > 0;

        if (headerBottomDistance < blurThreshold && isScrolled) {
            headerImage.classList.add(headerImageBlurClass);
        } else {
            headerImage.classList.remove(headerImageBlurClass);
        }
    }, observerOptions);

    observer.observe(headerWithImage);
}
